import ServerApiError from '../error/serverApiError';
import axios from 'axios';


export default async (path, method, headers, data) => {
    try {
        const result =  await axios({
            url: process.env.VUE_APP_BASE_API + path,
            method,
            headers,
            data
        })
        return result;
    } catch (e) {
        if(e.response){
            return new ServerApiError(e.response.data.message);
        }
        return new ServerApiError("somting_went_wrong");
    }
}